import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b9ead60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cw-dropped-file" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(this.file.name), 1),
    (this.fileUploadStarted(this.file.id))
      ? (_openBlock(), _createElementBlock("progress", {
          key: 0,
          class: "progress",
          value: this.getFileProgress(this.file.id),
          max: "100"
        }, _toDisplayString(this.getFileProgress(this.file.id)) + "% ", 9, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}